import React, { useEffect, useState } from 'react';
import styles from './DesignComment.module.scss';
import userImg from '../../../assets/Profile.png';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CommentDesign, DesignDetails } from '../../../global';

import { faCommentDots, faFlag, faXmark } from '@fortawesome/free-solid-svg-icons';

import { designCommentHourString, designUploadDateString, fullPathLogo } from '../../../helpers/utils';
import { useForm } from 'react-hook-form';
import axiosHelper from '../../../helpers/axiosHelper';
import userImagePlaceholder from '../../../assets/Profile.png';
import { useAuth } from '../../../context/AuthContext';

interface CommentMakerProps {
  design: DesignDetails;
  mutateCallback: (value: DesignDetails) => void;
}

interface IDesignComment {
  comment: CommentDesign;
  design: DesignDetails;
  replyCallback: (value: DesignDetails) => void;
  flagCallback: (value: DesignDetails) => void;
  deleteCallback: (value: DesignDetails) => void;
}

export const DesignCommentMaker: React.FC<CommentMakerProps> = ({ design, mutateCallback }) => {
  const { loggedUser } = useAuth();
  const [userLogo, setUserLogo] = useState('');

  useEffect(() => {
    console.log(loggedUser);
    if (!loggedUser) {
      setUserLogo(userImagePlaceholder);
      return;
    }
    if (loggedUser.logoAttachment) {
      setUserLogo(loggedUser.logoAttachment.s3Path);
    } else {
      setUserLogo(userImagePlaceholder);
    }
  }, [loggedUser]);
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<CommentUpload>();

  const onSubmit = (data: any) => {
    console.log(data.text);
    if (data.text) {
      console.log('ao');
      sendComment(data.text);
    }
  };

  const sendComment = async (text: string) => {
    if (loggedUser) {
      console.log('send');
      console.log(design.id);
      await axiosHelper.postComment(text, design?.id)?.then((response) => {
        console.log(response);
        mutateCallback(response);
        // props.update && props.update();
        reset(
          {
            text: '',
          },
          { keepErrors: true, keepDirty: true }
        );
      });
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row mb-2">
          <div className="col-2 col-md-1 fw-bold  text-center text-md-start ">
            <img alt="" className={`${styles.smallerImg}`} src={userLogo} />
          </div>

          <div className="col-10   col-md-11 ps-5   ">
            <textarea className="mb-5 align-items-center" rows={10} cols={10} {...register('text', { required: true })} />
          </div>
        </div>
        <div className="row mb-5 ">
          <div className="col-2  col-md-1 "></div>
          <div className="col-7  col-md-8 me-md-5  row ">
            <div className="col-9  col-md-4 ps-5  ">
              <button className="btn-dark-blue-materials submit full mb-4 rounded">
                <div>POST</div>
              </button>
            </div>
            <div className="col-12 col-md-8   mt-2  ">{!loggedUser && <span className="ps-4">(you must be logged in to comment)</span>}</div>
          </div>
        </div>
      </form>
    </>
  );
};

export interface CommentUpload {
  text: string;
}

export const ReplyCommentMaker: React.FC<IDesignComment> = (props) => {
  const { loggedUser } = useAuth();
  const [userLogo, setUserLogo] = useState(userImagePlaceholder);

  useEffect(() => {
    if (loggedUser?.logoAttachment != null) {
      setUserLogo(loggedUser.logoAttachment.s3Path);
    } else {
      setUserLogo(userImagePlaceholder);
    }
  }, [loggedUser]);

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<CommentUpload>();

  const onSubmit = (data: any) => sendReply(data.text);

  const sendReply = async (text: string) => {
    if (props.comment) {
      await axiosHelper.replyComment(text, props.comment.id, props.design.id)?.then((response) => {
        // console.log(response);
        props.replyCallback(response);
        reset(
          {
            text: '',
          },
          { keepErrors: true, keepDirty: true }
        );
      });
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row mb-2">
          <div className="col-2 col-md-1 fw-bold  text-center text-md-start ">
            <img alt="" className={`${styles.smallerImg}`} src={userLogo} />
          </div>

          <div className="col-10   col-md-9 ps-5   ">
            <textarea className="mb-5 align-items-center" rows={10} cols={10} {...register('text', { required: true })} />
          </div>
        </div>
        <div className="row mb-5">
          <div className="col-12 col-md-1 "></div>
          <div className="col-12 col-md-8 me-md-5  row ">
            <div className="col-12 col-md-4 ps-5  ">
              <button className="btn-dark-blue-materials submit full mb-4 rounded">
                <div>REPLY</div>
              </button>
            </div>
            <div className="col-12 col-md-8   mt-2  ">{!loggedUser && <span className="ps-4">(you must be logged in to reply)</span>}</div>
          </div>
        </div>
      </form>
    </>
  );
};

export const DesignComment: React.FC<IDesignComment> = (props) => {
  const { loggedUser, isGod } = useAuth();
  const [reply, setReply] = useState(false);
  const [replyVisible, setReplyVisible] = useState(false);
  const [flagVisible, setFlagVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);

  useEffect(() => {
    setReplyVisible(true);
    setDeleteVisible(false);
    setFlagVisible(true);
    if (loggedUser) {
      if (props.comment.dslUser.id === loggedUser.id) {
        console.log('metto flag invisibile');
        setFlagVisible(false);
        setDeleteVisible(true);
      }
      if (isGod()) {
        setFlagVisible(true);
        setDeleteVisible(true);
      }
    }
  }, [props.comment, loggedUser, isGod]);

  const deleteComment = async () => {
    await axiosHelper.deleteComment(props.comment?.id, props.design?.id)?.then((response) => {
      props.deleteCallback(response);
    });
  };

  const flagComment = async () => {
    await axiosHelper.flagComment(props.comment.id)?.then((response) => {
      console.log(response);
      props.flagCallback(response);
    });
  };

  const userImage = () => {
    if (props.comment?.dslUser.logoAttachment) {
      return props.comment.dslUser.logoAttachment.s3Path;
    }
    return userImg;
  };
  const replyCB = (newDesign: DesignDetails) => {
    props.replyCallback(newDesign);
    setReply(false);
  };
  return (
    <>
      <div className={`row  ${props.comment.publishedChildrenCommentsOrdered?.length ? 'mb-3' : 'mb-5'}`}>
        <div className="col-12 col-md-10 row ">
          <div className="col-3 col-md-2 text-start align-self-start  ">
            <img alt="" className={`${styles.smallerImg}`} src={userImage()} />
          </div>
          <div className="col-9 col-md-10 mt-2   text-start">
            <p>
              <span className="color-blue fw-bold">{props.comment?.username} </span>
              <span>{designUploadDateString(props.comment?.commentDate) + ' at ' + designCommentHourString(props.comment?.commentDate)}</span>
            </p>
            {props.comment.isCensored ? (
              <p>
                <i>This comment has been censored </i>
              </p>
            ) : (
              <p>{props.comment.text}</p>
            )}
            {loggedUser && (
              <div className="row ">
                <div className="col-lg-5 col-sm-7  d-flex flex-row align-items-center">
                  {replyVisible && (
                    <span className="d-flex align-items-center col-4  text color-dark_grey_50 cursor-pointer" onClick={() => setReply(!reply)}>
                      <FontAwesomeIcon style={{ fontSize: '1.5rem' }} icon={faCommentDots as IconProp} className="text color-blue pe-2" />
                      Reply
                    </span>
                  )}
                  {flagVisible && (
                    <span className="d-flex align-items-center col-3 me-2 text color-dark_grey_50 cursor-pointer" onClick={flagComment}>
                      <FontAwesomeIcon style={{ fontSize: '1.5rem' }} icon={faFlag as IconProp} className="text color-yellow me-2 " />
                      Flag
                    </span>
                  )}
                  {deleteVisible && (
                    <span className="d-flex align-items-center  col-4 text color-dark_grey_50 cursor-pointer" onClick={() => deleteComment()}>
                      <FontAwesomeIcon style={{ fontSize: '1.5rem' }} icon={faXmark as IconProp} className="text color-red me-2" />
                      Delete
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {props.comment.publishedChildrenCommentsOrdered &&
        props.comment.publishedChildrenCommentsOrdered.map((aComment: CommentDesign, index: number) => (
          <CommentResponse
            deleteCallback={props.deleteCallback}
            flagCallback={props.flagCallback}
            replyCallback={props.replyCallback}
            comment={aComment}
            design={props.design}
            key={index}
          />
        ))}
      {reply === true && (
        <ReplyCommentMaker deleteCallback={props.deleteCallback} flagCallback={props.flagCallback} replyCallback={replyCB} comment={props.comment} design={props.design} />
      )}
    </>
  );
};

const CommentResponse: React.FC<IDesignComment> = (props) => {
  const { loggedUser, isGod } = useAuth();
  const [flagVisible, setFlagVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  useEffect(() => {
    setDeleteVisible(false);
    setFlagVisible(true);
    if (loggedUser) {
      if (props.comment.dslUser.id === loggedUser.id) {
        setFlagVisible(false);
        setDeleteVisible(true);
      }
      if (isGod()) {
        setFlagVisible(true);
        setDeleteVisible(true);
      }
    }
  }, [props.comment, loggedUser, isGod]);

  const deleteComment = async () => {
    if (props.comment) {
      await axiosHelper.deleteComment(props.comment?.id, props.design?.id)?.then((response) => {
        console.log(response);
        props.deleteCallback(response);
      });
    }
  };

  const flagComment = async () => {
    console.log('ciao');
    if (props.comment) {
      console.log('no comment');
      await axiosHelper.flagComment(props.comment.id)?.then((response) => {
        console.log(response);
        props.flagCallback(response);
      });
    }
  };

  const userImage = () => {
    if (props.comment?.dslUser.logoAttachment) {
      return props.comment.dslUser.logoAttachment.s3Path;
    }

    return userImg;
  };

  return (
    <>
      <div className="row mb-5 ">
        <div className="col-1  col-md-1 "></div>
        <div className="col-9 col-md-9 mt-2 row   text-start ">
          <div className="row">
            <div className="col-4 col-md-2  text-center align-self-start">
              <img alt="" className={`${styles.smallerImg}`} src={userImage()} />
            </div>
            <div className=" col-8 col-md-10 mt-2 ">
              <span className="align-top ">
                <span className="color-blue fw-bold">{props.comment?.username}</span>{' '}
                <span>{designUploadDateString(props.comment?.commentDate) + ' at ' + designCommentHourString(props.comment?.commentDate)}</span>
              </span>
              {props.comment.isCensored ? (
                <p className="mt-3">
                  <i>This comment has been censored </i>
                </p>
              ) : (
                <p className="mt-3">{props.comment.text}</p>
              )}
              {loggedUser && (
                <div className="row ">
                  <div className="col-lg-5 col-sm-7 d-flex flex-row align-items-center">
                    {flagVisible && (
                      <span className="d-flex align-items-center col-3 me-3 text color-dark_grey_50 cursor-pointer" onClick={flagComment}>
                        <FontAwesomeIcon style={{ fontSize: '1.5rem' }} icon={faFlag as IconProp} className="text color-yellow me-2 " />
                        Flag
                      </span>
                    )}
                    {deleteVisible && (
                      <span className="d-flex align-items-center  col-4 text color-dark_grey_50 cursor-pointer" onClick={deleteComment}>
                        <FontAwesomeIcon style={{ fontSize: '1.5rem' }} icon={faXmark as IconProp} className="text color-red me-2" />
                        Delete
                      </span>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
